import { Tab, Tabs } from "@mui/material";
import { UTILITY_KIND, type UtilityKind } from "../models/Utility";

interface UtilityTabsProps {
	utility: UtilityKind;
	available: UtilityKind[];
	onUtilityChange: (utility: UtilityKind) => void;
}

export const UtilityTabs = ({
	utility,
	available,
	onUtilityChange,
}: UtilityTabsProps) => (
	<Tabs
		value={utility}
		onChange={(_, value: UtilityKind) => onUtilityChange(value)}
		aria-label="Utility type"
		variant="scrollable"
		scrollButtons={false}
		sx={{
			minHeight: 38,
			mb: "-1px",
			position: "relative",
			zIndex: 1,
			"& .MuiTabs-indicator": { display: "none" },
			"& .MuiTabs-flexContainer": { alignItems: "flex-end", gap: 0.5 },
			"& .MuiTab-root": {
				bgcolor: "#E7EAEE",
				border: 1,
				borderColor: "divider",
				borderTopLeftRadius: 8,
				borderTopRightRadius: 8,
				color: "#48525C",
				fontWeight: 500,
				minHeight: 38,
				px: 2.5,
				textTransform: "capitalize",
				"&:hover": { bgcolor: "#EFF1F4" },
			},
			"& .MuiTab-root.Mui-selected": {
				bgcolor: "background.paper",
				borderBottomColor: "background.paper",
				color: "text.primary",
				fontWeight: 600,
				minHeight: 42,
			},
			"& .MuiTab-root.Mui-disabled": {
				bgcolor: "#EDEFF2",
				color: "#A4ACB5",
			},
		}}
	>
		{Object.values(UTILITY_KIND).map((value) => (
			<Tab
				key={value}
				value={value}
				label={value}
				disabled={!available.includes(value)}
			/>
		))}
	</Tabs>
);
